import { render, staticRenderFns } from "./DeliverablesListWithVat.view.vue?vue&type=template&id=29a7395e&"
import script from "./DeliverablesListWithVat.view.vue?vue&type=script&lang=js&"
export * from "./DeliverablesListWithVat.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a7395e')) {
      api.createRecord('29a7395e', component.options)
    } else {
      api.reload('29a7395e', component.options)
    }
    module.hot.accept("./DeliverablesListWithVat.view.vue?vue&type=template&id=29a7395e&", function () {
      api.rerender('29a7395e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/common/partials/deliverables/view/DeliverablesListWithVat.view.vue"
export default component.exports